import React from 'react'
import { useStyles } from './standardLayout.css'

const StandardLayout: React.FC = ({ children }) => {
    const classes = useStyles()
    return <div className={classes.root}>{children}</div>
}

export default StandardLayout
